import React, { useEffect, useRef } from "react";
import "../../../public/pdfjs-5.1.91-dist/web/viewer.mjs";
import "../../../public/pdfjs-5.1.91-dist/build/pdf.mjs";
import "../../../public/pdfjs-5.1.91-dist/build/pdf.worker.mjs";
import "../../../public/pdfjs-5.1.91-dist/web/locale/locale.json";
import "../../../public/pdfjs-5.1.91-dist/web/locale/ja/viewer.ftl";
import helper from "./helper";

interface Props {
  src: string;
  visibleSaveButton?: boolean; // 保存ボタンの表示フラグ
  visiblePrintButton?: boolean; // 印刷ボタンの表示フラグ
}

const PdfViewer: React.FunctionComponent<Props> = ({
  src,
  visibleSaveButton = true,
  visiblePrintButton = true
}) => {
  const viewerRef = useRef<HTMLDivElement>(null);
  const backend = new helper();

  const resize = () => {
    const width = viewerRef.current?.getElementsByTagName("iframe")[0]
      .clientWidth;

    if (!width || !viewerRef.current) return;
    viewerRef.current.getElementsByTagName(
      "iframe"
    )[0].style.height = `${(width * 3) / 4 + 15}px`;
  };

  useEffect(() => {
    const element = viewerRef.current;

    if (!element) return;

    backend.init(src, element, { visibleSaveButton, visiblePrintButton });

    resize();

    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div ref={viewerRef} id="viewer" />;
};

export default PdfViewer;
